import md5 from 'md5'

const crypt = ({ mutation, data }) => md5(JSON.stringify({ mutation, data }))

export default crypt
